const appConfig = {
    apiPrefix: process.env.REACT_APP_API_PREFIX,
    apiPrefixExt: process.env.REACT_APP_API_PREFIX_EXT,
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: false,
}

export default appConfig
